import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoginPage from './components/LoginPage';
import ChatApp from './components/ChatApp';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // 로그인 여부와 관계없이 ChatApp을 렌더링
  return <ChatApp />;
}

export default App; 